export default __webpack_public_path__ + "static/media/count.f6c054f0.png";